import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { useDateTimeFormatter, useNumberFormatter } from "@opensea/i18n";
import { FlexColumn, SparkLineChart, TextBody } from "@opensea/ui-kit";
import { FloorPriceSparkLineChartFragment } from "./FloorPriceSparkLineChart.fragment";
export function FloorPriceSparkLineChart(t0) {
  const $ = _c(5);
  const {
    className,
    collection: collectionKey
  } = t0;
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(FloorPriceSparkLineChartFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  if ($[2] !== className || $[3] !== collection.analytics.sparkLineSevenDay) {
    t2 = <SparkLineChart className={className} data={collection.analytics.sparkLineSevenDay} getDate={_temp} getValue={_temp2} renderTooltip={FloorPriceSparkLineChartTooltip} />;
    $[2] = className;
    $[3] = collection.analytics.sparkLineSevenDay;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp2(d_0) {
  return d_0.price?.token.unit ?? 0;
}
function _temp(d) {
  return new Date(d.time);
}
function FloorPriceSparkLineChartTooltip(t0) {
  const $ = _c(14);
  const {
    item
  } = t0;
  const formatNumber = useNumberFormatter();
  const formatDate = useDateTimeFormatter();
  const t1 = item.price?.token.unit ?? 0;
  const t2 = item.price?.token.symbol;
  let t3;
  if ($[0] !== formatNumber || $[1] !== t1 || $[2] !== t2) {
    t3 = formatNumber(t1, {
      display: "full",
      suffix: t2
    });
    $[0] = formatNumber;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <TextBody>{t3}</TextBody>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== formatDate || $[7] !== item.time) {
    t5 = formatDate(new Date(item.time));
    $[6] = formatDate;
    $[7] = item.time;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <TextBody>{t5}</TextBody>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <FlexColumn className="gap-0.5">{t4}{t6}</FlexColumn>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}